var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.199 102.398C79.4755 102.398 102.398 79.4755 102.398 51.199C102.398 22.9226 79.4755 0 51.199 0C22.9226 0 0 22.9226 0 51.199C0 79.4755 22.9226 102.398 51.199 102.398Z",
    fill: "url(#paint0_linear_1_796)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_796",
    x1: 51.199,
    y1: 0,
    x2: 51.199,
    y2: 102.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791313"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBg);
export default __webpack_public_path__ + "static/media/icon_bg.d316fd3ea5be9437eee94e8c2664caa9.svg";
export { ForwardRef as ReactComponent };